import React from 'react'

import { ListGroupItem } from 'reactstrap'
import { observer } from 'mobx-react'

import PendingActionItemInfo from './PendingActionItemInfo'

export default observer(({ pendingAction, resource, session }) => {
  return (
    <ListGroupItem className="cases-list-item col px-lg-3 px-0 py-2 border-0 border-bottom">
      <PendingActionItemInfo pendingAction={pendingAction} resource={resource} session={session} />
    </ListGroupItem>
  )
})
